import styled from 'styled-components';
import {device} from 'styled/device';

type TaskPanelProps = {
  isCompletedTasks: boolean;
};

export const TasksPanelContainer = styled.div<TaskPanelProps>`
  width: 100%;
  padding: 16px;
  border-radius: 10px;
  background: ${props =>
    props.isCompletedTasks
      ? 'linear-gradient(0deg, rgba(255, 255, 255, 0.90) 0%, rgba(255, 255, 255, 0.90) 100%), #32D7BE'
      : 'linear-gradient(0deg,rgba(255, 255, 255, 0.9) 0%,rgba(255, 255, 255, 0.9) 100%),#dedede'};

  border: ${props =>
    props.isCompletedTasks ? '1px solid #32d7be' : '1px solid rgba(0, 0, 0, 0.1)'};
`;

export const TaskText = styled.div<{marginBottom?: string}>`
  color: ${props => props.theme.colors.$fontBlack};
  font-size: ${props => props.theme.fontSizes.$medium};
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: ${props => props.marginBottom ?? '0px'};
  & span {
    color: ${props => props.theme.colors.$n6};
  }
  @media (min-width: ${device.tablet}) {
    margin-bottom: 16px;
  }
`;

export const TasksInformation = styled(TaskText)`
  font-size: ${props => props.theme.fontSizes.$small};
  font-weight: 400;
  margin-bottom: 16px;
  color: #777e91;
  /* @media (min-width: ${device.tablet}) {
    margin-bottom: 48px; 
  } */
`;

export const SlideCustomItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 3px;
  & svg {
    border-radius: 50%;
  }
  @media (min-width: ${device.tablet}) {
    justify-content: center;
  }
`;
